import React from 'react'
import SubmitButtonRaw from '../../lib/components/FormFields/SubmitButtonRaw'

const PasswordSubmitButton = ({
    dirty,
    errors,
    disabled
}) => {
    const hasErrors = errors && 0 !== Object.keys(errors).length
    const buttonDisabled= (hasErrors || disabled || !dirty)

    return <SubmitButtonRaw
        className="jm-action-button jm-arrow-right jm-pwd-button"
        text='Passwort anfordern'
        disabled={buttonDisabled}
    />
}

export default PasswordSubmitButton